module.exports = __webpack_public_path__ + "static/lapras-167fa08e87afaec8e2da6ae88f801a43.png";